import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    marginTop: 135,
    marginBottom: 135,
    textAlign: 'center',

    [theme.breakpoints.down('sm')]: {
      marginTop: 24,
      marginBottom: 24,
    },
  },

  title: {
    color: '#77CC21',
    fontSize: 32,
    fontWeight: 'bold',
    lineHeight: 1.2,
    marginBottom: 16,

    [theme.breakpoints.up('sm')]: {
      fontSize: 40,
      marginBottom: 24,
    },
  },

  description: {
    color: '#5E6369',
    fontSize: 16,
    lineHeight: 1.5,
    marginBottom: 16,

    [theme.breakpoints.up('sm')]: {
      marginBottom: 40,
    },
  },

  actions: {
    display: 'flex',
    gap: 24,
    justifyContent: 'center',
  },

  button: {
    width: 192,
    whiteSpace: 'nowrap',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}));
